<template>
  <div class="app-container questionnaire-detail">
    <basic-container>
      <avue-tabs :option="option" @change="handleChange"></avue-tabs>
      <div v-show="type.prop==='tab1'">
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">封面:</el-col>
          <el-col :span="16">
            <div v-if="detail.coverUrl !== '--'" v-viewer>
              <img class="cover-image" :src="detail.coverUrl"/>
            </div>
            <span v-else>{{ detail.coverUrl }}</span>
          </el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">名称:</el-col>
          <el-col :span="16">{{ detail.name }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">名称（英文）:</el-col>
          <el-col :span="16">{{ detail.nameEn }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">描述:</el-col>
          <el-col :span="16">{{ detail.description }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">描述（英文）:</el-col>
          <el-col :span="16">{{ detail.descriptionEn }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">状态:</el-col>
          <el-col :span="16">{{ detail.status }}</el-col>
        </el-row>
        <!-- <el-row class="questionnaire-detail-item">
          <el-col :span="3">范围:</el-col>
          <el-col :span="16">{{detail.isPublic ? '所有人' : detail.enrollScopes.map(item => item.tagName).join(',')}}</el-col>
        </el-row> -->
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">开始时间:</el-col>
          <el-col :span="16">{{ detail.startTime }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">结束时间:</el-col>
          <el-col :span="16">{{ detail.endTime }}</el-col>
        </el-row>
        <!-- <el-row class="questionnaire-detail-item">
          <el-col :span="3">是否匿名:</el-col>
          <el-col :span="16">{{ detail.isAnonymous }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">是否公开:</el-col>
          <el-col :span="16">{{ detail.isPublic }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">是否显示创建者:</el-col>
          <el-col :span="16">{{ detail.isShowCreator }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">创建者联系方式:</el-col>
          <el-col :span="16">{{ detail.creatorContact }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">查看问卷结果:</el-col>
          <el-col :span="16">{{ detail.viewAnswerResultType }}</el-col>
        </el-row> -->
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">创建者名称:</el-col>
          <el-col :span="16">{{ detail.creatorName }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">创建时间:</el-col>
          <el-col :span="16">{{ detail.insertedTime }}</el-col>
        </el-row>
        <el-row class="questionnaire-detail-item">
          <el-col :span="3">更新时间:</el-col>
          <el-col :span="16">{{ detail.updatedTime }}</el-col>
        </el-row>
      </div>
      <div v-show="type.prop==='tab2'">
        
          <topic-card 
            v-for="(topic, index) in detail.topicList" 
            :key="index"
            :topic="topic"
            :order="index"
            :isView="true"
          />
        
      </div>
      <div v-show="type.prop==='tab3'">
        <div class="answered-member-list-filter">
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-input class="answered-member-list-filter-value" v-model.trim="answeredMemberSearch.name" @keyup.enter.native="getAnsweredMemberList" placeholder="Birth Name或Full Name" clearable size="small" ></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-input class="answered-member-list-filter-value" v-model.trim="answeredMemberSearch.unionId" @keyup.enter.native="getAnsweredMemberList" placeholder="员工号" clearable size="small"></el-input>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-button class="answered-member-list-filter-reset" size="small" @click="getAnsweredMemberList">立即筛选</el-button>
                <el-button class="answered-member-list-filter-search" size="small" @click="answeredMemberSearchReset">清除条件</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <avue-crud ref="crud"
          :option="answeredMemberListOption"
          :data="answeredMemberListData"
          :page="answeredMemberListPage"
          :table-loading="answeredMemberListLoading"
          @current-change="handleAnsweredMemberListCurrentChange"
          @size-change="handleAnsweredMemberListSizeChange"
          @sort-change="handleAnsweredMemberListSortChange">

          <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-download" size="small" @click="handleRecordExport" :loading="recordExportLoading">{{ recordExportName }}</el-button>
          </template>

          <template slot-scope="scope" slot="menu">
            <el-button type="text" icon="el-icon-view" size="mini" @click="handleViewRecord(scope.row)">查看问卷</el-button>
          </template>
        </avue-crud>
        <el-dialog
          v-if="recordDetailDialogVisible"
          :visible.sync="recordDetailDialogVisible"
          :title="recordDetailDialogTitle"
          top="5vh"
          width="32%"
          :close-on-click-modal="false"
          @close="recordDetail={}">
          <div class="questionniare-record-detail">
            <topic-card 
              v-for="(topic, index) in recordDetail" 
              :key="index"
              :topic="topic"
              :order="index"
              :isView="true"
              :isShowUserAnswer="true"
              @close="recordDetail={}"/>
          </div>
        </el-dialog>
      </div>    
    </basic-container>
  </div>
</template>
<script>
import { fetchEnrollScopes, getQuestionnaireDetail, getAnsweredMemberList, getQuestionnaireRecord, exportQuestionRecords } from '@/api/app/questionnaire';
import { answeredMemberListOption, publishOptions, viewAnswerResultTypeOptions, paperModeOptions, anonymousOptions, publicOptions } from '@/const/crud/app/questionnaire';
import TopicCard from '@/components/questionnaire/topic-card';
import { exporting } from '@/util/exportUtil';

export default {
  components: {
    TopicCard,
  },
  data() {
    return {
      answeredMemberListOption,
      viewAnswerResultTypeOptions,
      publishOptions,
      paperModeOptions,
      anonymousOptions,
      publicOptions,
      detail: {},
      type:{},
      option:{
        column: [{
          icon:'el-icon-info',
          label: '基本信息',
          prop: 'tab1',
        }, {
          icon:'el-icon-tickets',
          label: '所有题目',
          prop: 'tab2',
        }, {
          icon:'el-icon-success',
          label: '已作答名单',
          prop: 'tab3',
        }]
      },
      answeredMemberSearch: {
        currentPage: 1,
        pageSize: 10,
        sortField: '',
        sortPolicy: '',
        name: '',
        unionId: '',
      },
      answeredMemberListData: [],
      answeredMemberListPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      answeredMemberListLoading: false,
      recordDetailDialogVisible: false,
      recordDetailDialogTitle: "问卷作答详情",
      recordDetail: {},
      recordExportLoading: false,
      recordExportName: '导出',
    }
  },
  created(){
    this.type = this.option.column[0];
  },
  mounted () {
    this.id = this.$route.params.id
    this.getDetail();
    this.getAnsweredMemberList();
  },
  methods:{
    handleChange(column) {
      this.type = column
    },
    getDetail() {
      getQuestionnaireDetail(this.id).then(async res => {
        this.detail = await this.formatData(res.data.data)
      }).catch(error => {
        this.$message({
          message: '获取问卷详情失败',
          type: 'error'
        })
      })
    },
    async formatData(record) {
      
      record.viewAnswerResultType = viewAnswerResultTypeOptions.find((v) => (v.value == record.viewAnswerResultType)).label;
      record.paperMode = paperModeOptions.find((v) => (v.value == record.paperMode)).label;
      record.status = publishOptions.find((v) => (v.value == record.isPublish)).label;
      
      record.isAnonymous = record.isAnonymous ? '是' : '否';
      record.isShowCreator = record.isShowCreator ? '是' : '否';

      record.coverUrl = !record.coverUrl ? '--': record.coverUrl;
      record.startTime = !record.startTime ? '--': record.startTime;
      record.endTime = !record.endTime ? '--': record.endTime;
      if (record.questionnaireScopeList && record.questionnaireScopeList.length > 0) {
        await fetchEnrollScopes().then(({data}) =>{
          if (data.code === 0) {
            record.enrollScopes = data.data.filter(item => record.questionnaireScopeList.includes(item.id));
          } else {
            this.$message.error(data.msg);
          }
        });
      }
      if (!record.creatorName) {
        record.creatorName = '--';
      } else {
        // 获取到的createName固定格式为admin:xxx, 需要去掉admin:
        const matchResult = record.creatorName.match(/(?<=admin:)([\s\S]*)/g);
        record.creatorName = !matchResult ? '--': matchResult[0];
      }
      record.creatorContact = !record.creatorContact ? '--': record.creatorContact;

      record.topicList = record.topicVOList;
      delete record.topicVOList;

      record.topicList.forEach(topic => {
        topic.optionList = topic.optionVOList;
        delete topic.optionVOList;
      });

      return record;
    },
    answeredMemberSearchReset() {
      this.answeredMemberSearch.name = '';
      this.answeredMemberSearch.unionId = '';
      this.getAnsweredMemberList(this);
    },
    handleAnsweredMemberListCurrentChange(val) {
      this.answeredMemberListPage.currentPage = val;
      this.answeredMemberSearch.current = val;
      this.getAnsweredMemberList(this);
    },
    handleAnsweredMemberListSizeChange(val) {
      this.answeredMemberListPage.pageSize = val;
      this.answeredMemberSearch.pageSize = val;
      this.getAnsweredMemberList(this);
    },
    handleAnsweredMemberListSortChange(val) {
      if (val.prop == 'insertedTime') {
        this.answeredMemberSearch.sortField = 'inserted_time'
      } else {
        this.answeredMemberSearch.sortField = ''
      }
      if (val.order == 'ascending') {
        this.answeredMemberSearch.sortPolicy = 'asc'
      } else if (val.order == 'descending') {
        this.answeredMemberSearch.sortPolicy = 'desc'
      } else {
        this.answeredMemberSearch.sortPolicy = ''
      }
      this.getAnsweredMemberList();
    },
    isNotEmpty(searchValue) {
      return searchValue != '' && searchValue.trim() != '';
    },
    generateFilterParams() {
      let params = {
        current: this.answeredMemberSearch.current,
        size: this.answeredMemberSearch.pageSize,
      };

      params.questionnaireId = this.id;

      if (this.isNotEmpty(this.answeredMemberSearch.name)) {
        params.name = this.answeredMemberSearch.name;
      }

      if (this.isNotEmpty(this.answeredMemberSearch.unionId)) {
        params.unionId = this.answeredMemberSearch.unionId;
      }

      if (this.isNotEmpty(this.answeredMemberSearch.sortField)) {
        params.sortField = this.answeredMemberSearch.sortField;
      } else {
        params.sortField = 'inserted_time';
        this.answeredMemberSearch.sortField = params.sortField;
      }

      if (this.isNotEmpty(this.answeredMemberSearch.sortPolicy)) {
        params.sortPolicy = this.answeredMemberSearch.sortPolicy;
      } else {
        params.sortPolicy = 'desc';
        this.answeredMemberSearch.sortPolicy = params.sortPolicy;
      }

      return params;
    },
    getAnsweredMemberList() {
      this.answeredMemberListLoading = true;
      getAnsweredMemberList(this.generateFilterParams()).then(response => {
        this.answeredMemberListData = response.data.data.records;
        this.answeredMemberListPage.total = response.data.data.total;
        this.answeredMemberListLoading= false;
      }).catch(error => {
        console.log(error);
        this.answeredMemberListLoading= false;
      })
    },
    handleViewRecord({ questionnaireRecordId }) {
      this.recordDetailDialogVisible = true;
      getQuestionnaireRecord(questionnaireRecordId).then(response => {
        this.recordDetail = response.data.data.topicVOList;
      });
    },
    handleRecordExport() {
      if (this.answeredMemberSearch.currentPage === 1 && this.answeredMemberListData.length === 0) {
        return this.$message({
          message: "导出失败，没有可导出的信息",
          type: "warning",
        })
      }
      exportQuestionRecords(this.generateFilterParams()).then(response => {
        if (response.status === 200 && response.data && response.data.data) {
          this.recordExportLoading = true;
          this.recordExportName = "导出中...";
          exporting(response.data.data, this.recordExportCallback)
        } else {
          this.$message({
            message: '导出失败',
            type: 'warning',
            showClose: true,
          });
        }
      })
    },
    recordExportCallback(result) {
      this.recordExportLoading = false;
      this.recordExportName = '导出';
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success',
        });
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.questionnaire-detail {
  &-item {
    font-size: 16px;
    margin: 10px 0;
  }
  .cover-image {
    width: 100px;
    height: 100px;
    cursor: pointer;
  }
  .answered-member-list-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}

.questionniare-record-detail {
  height: 80vh;
  overflow: auto;
}

/deep/ .topic-container .el-col-20 {
  width: 95%;
}
</style>
